// extracted by mini-css-extract-plugin
export var container = "rights-module--container--yF3-1";
export var webRight = "rights-module--webRight--v3lM+";